import { lazy, Suspense, useCallback, useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { createUseStyles } from 'react-jss';
import { useSelector } from 'react-redux';
import { userSelector } from '../../../../appStore/commonSlice';
import { ROLES } from '../../../../const';
import { ConcursoProvider, useConcurso } from '../../../../providers/ConcursoProvider';
import FullLoading from '../../../CompUtils/FullLoading';
import ConcursoData from '../ConcursoData';
import { activoSelector } from '../gestionConcursoSlice';
import TramitarComiteGeneral from './ComiteGeneral/TramitarComiteGeneral';
import TramitarCC from './CoordinadorConcursal/TramitarCC';
import TramitarDirector from './Director/TramitarDirector';
import TramitarLegales from './Legales/TramitarLegales';

const ListadoActas = lazy(() => import('../ListadoActas/ListadoActas'));

const useStyles = createUseStyles({
  separator: {
    margin: '10px 0',
    borderWidth: 2,
    borderStyle: 'solid',
    borderImage: `linear-gradient(
        to right, 
        rgba(0, 0, 0, 0),
        lightgray, 
        rgba(0, 0, 0, 0)
      ) 1 1 100%;`,
  },
});
const TramiteConcurso = (props) => {
  const classes = useStyles();
  const activo = useSelector(activoSelector);

  const hayActivo = activo && Object.keys(activo).length > 0;

  useEffect(() => {
    document.title = 'Concursar - Tramitar Concurso';
  });

  return hayActivo ? (
    <>
      <Container>
        <Row>
          <Col>
            <h3>{activo.titulo}</h3>
          </Col>
        </Row>
        <Row>
          <Col>
            <h5>Etapa actual: {activo.etapaLlamadoConcurso.nombre}</h5>
          </Col>
        </Row>
        <ConcursoData concurso={activo} />
      </Container>
      <div className={classes.separator}></div>
      <ConcursoProvider concurso={activo}>
        <EtapaATramitar />
      </ConcursoProvider>
    </>
  ) : (
    <Container>
      <Row>
        <Col className="text-center">
          <span className="h6 text-danger">No hay un concurso seleccionado para tramitar.</span>
        </Col>
      </Row>
    </Container>
  );
};

const EtapaATramitar = () => {
  const concurso = useConcurso();
  const { esCoordinadorConcursal, esComite } = concurso;
  const etapa = concurso.etapaLlamadoConcurso.idEtapaLlamadoConcurso;
  const { roles } = useSelector(userSelector);

  const renderInner = useCallback(() => {
    const isLegales = roles.includes(ROLES.LEGALES);
    const isDirector = roles.includes(ROLES.DIRECTOR);

    // SI ES ROL COMITE && CC || CUALQUIER OTRO ROL VOY A TENER ESTA LOGICA
    if (!isDirector && !esCoordinadorConcursal && !isLegales && etapa < 8) {
      return (
        <Container>
          <ListadoActas />
        </Container>
      );
    }

    if (esComite && !esCoordinadorConcursal) {
      return <TramitarComiteGeneral />;
    } else if (esCoordinadorConcursal) {
      return <TramitarCC />;
    } else if (isDirector) {
      return <TramitarDirector />;
    } else if (isLegales) {
      return <TramitarLegales />;
    } else {
      return 'No cuenta con los permisos para gestionar este concurso: ROL NO AUTORIZADO';
    }

    //SI ES (COMITE  && !CC) VA LA OTRA LOGICA
    //aca tendria casi la misma logica que un usuario normal pero con la diferencia que tiene acceso a actas privadas y las puede firmas

    //SI ES USER NORMAL VA LA OTRA LOGICA
    //user normal solo deberia ver de la etapa 8 en adelante -> tengo que llamar a
  }, [etapa, concurso, roles, esCoordinadorConcursal]);

  return <Suspense fallback={<FullLoading show />}>{renderInner()}</Suspense>;
};

export default TramiteConcurso;
